/* 🤖 this file was generated by svg-to-ts */
export const prizmIconsArrowsDirectionToTheLines: {
  name: 'arrows-direction-to-the-lines';
  data: string;
} = {
  name: 'arrows-direction-to-the-lines',
  data: `<svg fill="none" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24"><path fill-rule="evenodd" clip-rule="evenodd" d="M4 3a1 1 0 0 0-2 0v18a1 1 0 1 0 2 0V3Zm17-1a1 1 0 0 1 1 1v18a1 1 0 1 1-2 0V3a1 1 0 0 1 1-1Zm-6.707 5.707a1 1 0 0 1 1.414-1.414l2 2a1 1 0 0 1 0 1.414l-2 2a1 1 0 0 1-1.414-1.414l.293-.293H11a1 1 0 1 1 0-2h3.586l-.293-.293Zm-4.586 6a1 1 0 0 0-1.414-1.414l-2 2a1 1 0 0 0 0 1.414l2 2a1 1 0 0 0 1.414-1.414L9.414 16H13a1 1 0 1 0 0-2H9.414l.293-.293Z" fill="currentColor"/></svg>`,
};
